const getShouldHideSeparator = (activeIndex: number | null, index: number) => {
  if (activeIndex === null) return false;
  return index === activeIndex || index === activeIndex - 1;
};

export default getShouldHideSeparator;
